import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, of, shareReplay} from 'rxjs';

export interface AppVersionResponse {
  version?: string;
  source?: string;
  environment?: string;
  timestamp?: string;
}

export interface AppVersionMetadata {
  version: string;
  source: string;
  environment: string;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly http = inject(HttpClient);

  private readonly fallback: AppVersionMetadata = {
    version: 'local',
    source: 'local',
    environment: 'local'
  };

  private readonly versionResponse$ = this.http.get<AppVersionResponse>(`/version.json?ts=${Date.now()}`).pipe(
    map((response) => ({
      version: response.version || this.fallback.version,
      source: response.source || this.fallback.source,
      environment: response.environment || this.fallback.environment,
      timestamp: response.timestamp
    })),
    catchError(() => of(this.fallback)),
    shareReplay({bufferSize: 1, refCount: true})
  );

  readonly metadata$ = this.versionResponse$;

  readonly versionLabel$ = this.metadata$.pipe(
    map((metadata) => this.buildLabel(metadata))
  );

  private buildLabel(metadata: AppVersionMetadata): string {
    return metadata.version || this.fallback.version;
  }
}
